import { call, put, takeLatest, all } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_API_URL } from '../../api/config';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchCompetitorsRequest,
  fetchCompetitorsSuccess,
  fetchCompetitorsFailure,
} from '../slices/competitorsSlice';
import type {
  BroadCompetitorResponse,
  DirectCompetitorResponse,
  BroadCompetitorData,
  DirectCompetitorData,
} from '../../components/competitors/types';

function* fetchCompetitorsSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;

    // Fetch both broad and direct competitors in parallel
    const [broadResponse, directResponse] = yield all([
      call(axios.get, `${ENDPOINTS.broad_competitors}/${restaurantId}`),
      call(axios.get, `${ENDPOINTS.direct_competitors}/${restaurantId}`),
    ]);

    const broadData: BroadCompetitorResponse = broadResponse.data;
    const directData: DirectCompetitorResponse = directResponse.data;

    const broadCompetitor: BroadCompetitorData | null =
      broadData.data && broadData.data.length > 0 ? broadData.data[0] : null;

    const directCompetitors: DirectCompetitorData[] = directData.data || [];

    yield put(
      fetchCompetitorsSuccess({
        broadCompetitor,
        directCompetitors,
      })
    );
  } catch (error: any) {
    yield put(
      fetchCompetitorsFailure(
        error.response?.data?.message || error.message || 'Failed to fetch competitors data'
      )
    );
  }
}

export function* competitorsSaga() {
  yield takeLatest(fetchCompetitorsRequest.type, fetchCompetitorsSaga);
}
